import { getVersion } from '@/services/version';

export default {
  getVersionBack: async ({ commit }) => {
    try {
      const { data } = await getVersion();

      if (data) {
        commit('setVersionBack', data);
      }
    } catch (error) {
      throw Error("Ocorreu um erro de API.");
    }
  }
};